import {useEffect} from "react";
import isNull from "../../../../../../mixin/isNull";
import {Divider, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import Typography from "@mui/material/Typography";
import useQuotationRepository from "../../../../../../repository/insurance/useQuotationRepository";
import useQuotationItemRepository from "../../../../../../repository/insurance/useQuotationItemRepository";
import useHelper from "../../../../../../use/useHelper";
import Box from "@mui/material/Box";

export default function ({interventionId, title = "Éléments présents sur le devis :"}) {
    const helper = useHelper();
    const quotationRepository = useQuotationRepository();
    const quotationItemRepository = useQuotationItemRepository();

    /** @type Quotation */
    const quotation = quotationRepository.findOneByInterventionId(interventionId).select();
    /** @type QuotationItem[] */
    const items = quotationItemRepository.findAllByIds(quotation?.getQuotationItemsId()).select();

    useEffect(() => {
        quotationRepository.findOneByInterventionId(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(quotation)) return;

        quotationItemRepository.findAllByIds(quotation.getQuotationItemsId()).exec();
    }, [quotation?.getId()]);

    if (isNull(quotation) || items.length === 0) return null;

    return (
        <>
            <Typography fontWeight={"bold"}>
                {title}
            </Typography>
            <Table size="small" data-test="insurance-quotation-details">
                <TableHead>
                    <TableRow>
                        <TableCell>Nom</TableCell>
                        <TableCell>Qté</TableCell>
                        <TableCell>HT</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        items.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell width={"60%"}>
                                    <Typography fontSize="small">
                                        {item.getName()}
                                    </Typography>
                                </TableCell>
                                <TableCell width={"15%"}>{item.getQuantity()}</TableCell>
                                <TableCell width={"25%"}>
                                    {helper.priceFormatter(item.getPricing() / 100)} €
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            <Box mt={1}>
                <Divider/>
                <Box display="flex" justifyContent="flex-end" mt={1}>
                    <Typography variant="caption">
                        TVA {quotation.getVat()} %
                    </Typography>
                </Box>
            </Box>
        </>
    );
}
